import { Wallet } from '@/features/wallet/components/Wallet'
import { Page } from '@/ui-kit'

export const WalletPage = () => (
  <Page>
    <Wallet />
  </Page>
)

export default WalletPage
